import LayoutStatic from "@/layouts/LayoutStatic/LayoutStatic.vue";
import WordService from "@/services/WordService";

export default {
    components: {
        LayoutStatic
    },
    data() {
        return {
            layout: LayoutStatic,
            wordList: [],
            status: {
                err: false,
                errmsg: ""
            }
        };
    },
    methods: {
        getWordList() {
            WordService.getWordIndex(20000).then(res => {
                const data = res.data;
                this.wordList = data.data;
            });
        }
    },
    mounted() {
        this.getWordList();
    },
    metaInfo() {
        const word = this.word || this.$route.params.slug; // Use the slug until the proper word spelling is available from the API call.
        return {
            title: this.$t(`sentenceIndexPageMetaTitle`),
            link: [
                {
                    rel: "canonical",
                    href: `https://es.yourdictionary.com/indice`
                }
            ]
        };
    }
};



// WEBPACK FOOTER //
// ./src/pages/Indice/Indice.js